// src/pages/Quote.js
import React, { useState } from "react";
import axios from "axios";
import "./Quote.css"; // Import updated CSS

function Quote() {
  const [formData, setFormData] = useState({
    fullName: "",
    relationship: "",
    phone: "",
    email: "",
    departure: "",
    destination: "",
    medicalInfo: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await axios.post("php/quote.php", formData, {
        headers: { "Content-Type": "application/json" },
      });

      setMessage(response.data.message);
    } catch (error) {
      setMessage("Failed to send request. Please try again.");
    }
  };

  return (
    <div className="quote-container">
      {/* Title */}
      <h1 className="quote-title">Request Turf / Construction Services – Calimesa Turf Center & Graystone Construction</h1>

      <form onSubmit={handleSubmit} className="quote-form">
        <label>Full Name (Homeowner or Contractor)</label>
        <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} required />

        <label>Best Contact Phone Number</label>
        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />

        <label>Email Address (for confirmations)</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} />

        <label>Select the Type of Service Requested</label>
        <select name="relationship" value={formData.relationship} onChange={handleChange} required>
          <option value="">-- Please Select --</option>
          <option value="Turf Pickup - DIY">Turf Pickup – DIY Homeowner</option>
          <option value="Turf Pickup - Licensed Contractor">Turf Pickup – Licensed Contractor</option>
          <option value="Turf Installation">Full Turf Installation</option>
          <option value="Landscape Design & Build">Full Landscape Design & Build</option>
          <option value="Irrigation / Drainage Work">Irrigation / Drainage Work</option>
          <option value="Virtual Consultation">Virtual Consultation (Video Call)</option>
          <option value="On-Site Consultation">On-Site Consultation / Estimate</option>
        </select>

        <label>Preferred Date / Time for Appointment or Pickup</label>
        <input type="datetime-local" name="departure" value={formData.departure} onChange={handleChange} />

        <label>Project Address or Pickup Location</label>
        <input
          type="text"
          name="destination"
          value={formData.destination}
          onChange={handleChange}
          placeholder="Street address, city, and any access notes"
        />

        <label>Project Details / Notes for Our Team</label>
        <textarea
          name="medicalInfo"
          value={formData.medicalInfo}
          onChange={handleChange}
          placeholder="Describe your turf project, square footage, access, timeline, or any details for virtual/onsite appointment."
        ></textarea>

        <button type="submit" className="submit-btn">Submit Request</button>
      </form>

      {message && <p className="message">{message}</p>}
    </div>
  );
}

export default Quote;